import { useCallback, useEffect, useState, memo } from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { baricon, baricon1, user06, PrakurtiLogoWhite } from './imagepath';
import Loader from './loader';
import { useSelector } from 'react-redux';
import { useSidebar } from '../context/SidebarContext';

const Header = memo(() => {
  const [logoutClicked, setLogoutClicked] = useState(false);
  const { userDetails } = useSelector(state => state.auth);
  const { toggleDesktopCollapse, toggleMobileMenu, isDesktopCollapsed } = useSidebar();

  const handleSidebarToggle = useCallback(() => {
    toggleDesktopCollapse();
  }, [toggleDesktopCollapse]);

  const handleMobileMenuToggle = useCallback((e) => {
    e.preventDefault();
    toggleMobileMenu();
  }, [toggleMobileMenu]);

  // Apply mini-sidebar class to document root for CSS selectors to work
  useEffect(() => {
    const html = document.documentElement;
    if (isDesktopCollapsed) {
      html.classList.add('mini-sidebar');
    } else {
      html.classList.remove('mini-sidebar');
    }
  }, [isDesktopCollapsed]);

  const handleDrawerToggle = useCallback(() => {
    const div = document.querySelector('.main-wrapper');
    if (div?.className?.includes('open-msg-box')) {
      div?.classList?.remove('open-msg-box');
    } else {
      div?.classList?.add('open-msg-box');
    }
  }, []);

  const handleLogout = useCallback(() => {
    setLogoutClicked(true);
    setTimeout(() => {
      localStorage.removeItem('token');
      setLogoutClicked(false);
      window.location.href = '/';
    }, 1000);
  }, []);

  useEffect(() => {
    const handleFullscreenToggle = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector('.win-maximize');
    if (maximizeBtn) {
      maximizeBtn.addEventListener('click', handleFullscreenToggle);
    }

    return () => {
      if (maximizeBtn) {
        maximizeBtn.removeEventListener('click', handleFullscreenToggle);
      }
    };
  }, []);

  return (
    <div className="main-wrapper">
      <Loader IsModal={logoutClicked} />
      <div className="header" style={{ zIndex: 800 }}>
        <div className="header-left">
          <Link to="/admin-dashboard" className="logo">
            <img
              src={PrakurtiLogoWhite}
              alt="Prakruti Logo"
              className="header-logo-img"
            />{' '}
          </Link>
        </div>
        <Link id="toggle_btn" onClick={handleSidebarToggle} aria-label="Toggle sidebar">
          <img src={baricon} alt="Toggle sidebar" />
        </Link>
        <Link
          id="mobile_btn"
          className="mobile_btn float-start"
          onClick={handleMobileMenuToggle}
          aria-label="Toggle mobile menu"
        >
          <img src={baricon1} alt="Toggle mobile menu" />
        </Link>
        <ul className="nav user-menu float-end">
          <li className="nav-item dropdown has-arrow user-profile-list">
            <Link
              to="#"
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="user-names">
                {/* <h5>Liam Michael </h5> */}
                <span>{userDetails?.[0]?.name}</span>
              </div>
              <span className="user-img">
                <img
                  src={user06}
                  alt={userDetails?.[0]?.name || 'Admin'}
                  className="user-avatar"
                />
              </span>
            </Link>
            <div className="dropdown-menu user-profile-dropdown">
              <div className="dropdown-header">
                <div className="user-profile-info">
                  <img
                    src={user06}
                    alt={userDetails?.[0]?.name || 'Admin'}
                    className="user-profile-avatar"
                  />
                  <div className="user-profile-details">
                    <h6 className="user-profile-name">{userDetails?.[0]?.name || 'Admin'}</h6>
                    <span className="user-profile-role">
                      {userDetails?.[0]?.role?.description || 'User'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-item user-profile-email">
                <FeatherIcon icon="mail" className="me-2" size={16} />
                <span className="email-text">{userDetails?.[0]?.email || '-'}</span>
              </div>
              <div className="dropdown-item user-profile-role-item">
                <FeatherIcon icon="user" className="me-2" size={16} />
                <span className="role-text">
                  {userDetails?.[0]?.role?.description || '-'}
                </span>
              </div>
              <div className="dropdown-divider"></div>
              <Link
                className="dropdown-item logout-item"
                onClick={handleLogout}
                aria-label="Logout"
              >
                <FeatherIcon icon="log-out" className="me-2" size={16} />
                <span className="logout-text">Logout</span>
              </Link>
            </div>
          </li>
        </ul>
        <div className="dropdown mobile-user-menu float-end">
          <Link to="#" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" aria-label="User menu">
            <i className="fa-solid fa-ellipsis-vertical" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to="/profile" aria-label="My Profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="edit-profile.html" aria-label="Edit Profile">
              Edit Profile
            </Link>
            <Link className="dropdown-item" to="/settings" aria-label="Settings">
              Settings
            </Link>
            <Link
              className="dropdown-item"
              onClick={handleLogout}
              aria-label="Logout"
            >
              Logout
            </Link>
          </div>
        </div>
      </div>

      {/* Notifications */}
      <div className="notification-box">
        <div className="msg-sidebar notifications msg-noti">
          <div className="topnav-dropdown-header">
            <span>Messages</span>
          </div>
          <div className="drop-scroll msg-list-scroll" id="msg_list">
            <ul className="list-box">
              <li>
                <Link to="#" aria-label="Message from Richard Miles">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">R</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Richard Miles </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from John Doe">
                  <div className="list-item new-message">
                    <div className="list-left">
                      <span className="avatar">J</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">John Doe</span>
                      <span className="message-time">1 Aug</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Tarah Shropshire">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">T</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Tarah Shropshire </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Mike Litorus">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">M</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Mike Litorus</span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Catherine Manseau">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">C</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Catherine Manseau </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Domenic Houston">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">D</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Domenic Houston </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Buster Wigton">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">B</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Buster Wigton </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Rolland Webber">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">R</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Rolland Webber </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Claire Mapes">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">C</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author"> Claire Mapes </span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Melita Faucher">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">M</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Melita Faucher</span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Jeffery Lalor">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">J</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Jeffery Lalor</span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Loren Gatlin">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">L</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Loren Gatlin</span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="#" aria-label="Message from Tarah Shropshire">
                  <div className="list-item">
                    <div className="list-left">
                      <span className="avatar">T</span>
                    </div>
                    <div className="list-body">
                      <span className="message-author">Tarah Shropshire</span>
                      <span className="message-time">12:28 AM</span>
                      <div className="clearfix"></div>
                      <span className="message-content">
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
          <div className="topnav-dropdown-footer">
            <Link to="/chat" aria-label="See all messages">See all messages</Link>
          </div>
        </div>
      </div>
    </div>
  );
});

Header.displayName = 'Header';

export default Header;